// extracted by mini-css-extract-plugin
export default {"item":"DeviceSessions_item__79MsG"};